
import { useState } from 'react';

import styled from "styled-components"

import Habilidades from './components/Habilidades';
import ProyectosComponent from './components/Proyectos';

import {ReactComponent  as IconoUbi} from './icons/ubicacion.svg'
import {ReactComponent  as IconoTrabajo} from './icons/trabajo.svg'
import {ReactComponent  as IconoDescargar} from './icons/download.svg'
import Footer from './components/Footer';

export default function App() {

    const [getSection, setSection] = useState(1);

    document.title = "Felipe Blanco"

    return (
        <Content>
            <Container>
               <Banner>
                    <img alt="banner" src={`https://i.blogs.es/016f69/developers/1366_2000.jpg`}/>
               </Banner>
               <UserImgContainer>
                    <UserImg>
                        <img src={`./foto.jpg`} alt=""/>
                    </UserImg>
                    <FollowBtnContainer>
                        <BtnFollow>Enviar mensaje</BtnFollow>
                    </FollowBtnContainer>
                    <NameContainer>
                        <span>Felipe Blanco</span>
                    </NameContainer>
                    <div style={{marginBottom:'15px'}}>
                        Desarrollador FullStack
                    </div>
                    <div>
                        Estudiante de Analista de Sistemas | CEO y Programador de <a href="https://getyn.com.ar" style={{color:'#fff', fontWeight:'800'}}>Getyn</a> | Afisionado a la programación y la música
                    </div>
                    <TagsContainer>
                        <span><IconoTrabajo fill="#808080" style={{width:'20px', height:'20px', marginRight:'4px'}} />Disponible</span>
                        <span><IconoDescargar fill="#808080" style={{width:'24px', height:'24px'}}/>Descargar CV</span>
                        <span><IconoUbi fill="#808080" style={{width:'30px', height:'30px'}} />Villa María, Córdoba</span>
                    </TagsContainer>
               </UserImgContainer>
               <div style={{flex:1}}>
                    <ChoiseContainer>
                        <ChoiseItem selected={getSection === 1} onClick={() => setSection(1)}>Sobre mi</ChoiseItem>
                        <ChoiseItem selected={getSection === 2} onClick={() => setSection(2)}>Proyectos</ChoiseItem>
                        <ChoiseItem selected={getSection === 3} onClick={() => setSection(3)}>Habilidades</ChoiseItem>
                        <ChoiseItem selected={getSection === 4} onClick={() => setSection(4)}>Contacto</ChoiseItem>
                    </ChoiseContainer>
                    <div>
                        {getSection === 1 && <SobreMiComponent />}
                        {getSection === 2 && <ProyectosComponent />}
                        {getSection === 3 && <Habilidades />}
                        {getSection === 4 && <ContactoComponent />}
                    </div>
               </div>
               <Footer/>
            </Container>

        </Content>
    )
}

const ContactoComponent = () => {
    return (
        <div>
            Contacto
        </div>
    )
}

const SobreMiComponent = () => {
    return (
        <div style={{padding:'20px'}}>
            Hola 👋! Me llamo Felipe, tengo 22 años y soy de Villa María, Córdoba.<br />
            A los 15 años ingresé al mundo de la programación, y desde entonces se convirtió en unas de mis actividades favoritas.<br/>
            Soy una persona ambiciosa y curiosa, por lo que me gusta aprender constantemente sobre distintas tecnologías, aunque me centro mucho en React y Express.<br/>
            Me gustaría poder convertir mi hobbie en trabajo, por eso es que estoy estudiando Analista de Sistemas en el Instituto Leibnitz. Actualmente estoy en mi último año de la carrera.
        </div>
    )
}

const TagsContainer = styled.div`
display:flex;
gap:20px;
margin:20px 0;
color:#808080;

& > span {
    display:flex;
    align-items:center;
}
@media screen and (max-width:700px) {
    & > span {
        font-size:12px;
    }
}
`

const ChoiseItem = styled.span`
user-select:none;
cursor:pointer;
transition:color 0.2s;

@media screen and (max-width:700px) {
    font-size:14px;
}

${props => props.selected === true ? `
    color:#fff;
    border-bottom:3px solid #6b40a3;
    ` : 
    `
    color:#808080;
    border-bottom:3px solid transparent;
`}

&:hover {
    color:#fff;
}

`
const ChoiseContainer = styled.div`
display:flex;
justify-content:space-evenly;

`

const NameContainer = styled.div`
font-size:38px;
font-weight:700;


@media screen and (max-width:700px) {
    font-size:34px;
}
`

const BtnFollow = styled.button`
padding:10px 20px;
border-radius:20px;
border:0;
outline:0;
cursor:pointer;

background:transparent;
color:#fff;
border:3px solid #fff;
font-size:14px;
font-weight:800;

transition: all 0.2s;

&:hover {
    background:#fff;
    color:#1e1f24;
}


@media screen and (max-width:700px) {
    font-size:12px;
    padding:6px 14px;
}
`
const FollowBtnContainer = styled.div`
width:100%;
height:80px;
display:flex;
justify-content:flex-end;
align-items:flex-start;

@media screen and (max-width:700px) {
    height:60px;
}
`

const UserImg = styled.div`
width:165px;
height:165px;
background:gray;
border-radius:100%;
border:4px solid #fff;
position:absolute;
top:-80px;
overflow:hidden;

@media screen and (max-width:700px) {
    width:120px;
    height:120px;
    top:-60px;
}

& > img {
    width:100%;
}
`

const UserImgContainer = styled.div`
position:relative;
padding:20px 40px;
@media screen and (max-width:700px) {
    padding:10px 20px;
}
`

const Banner = styled.div`
width:100%;
height:240px;
background:blue;
overflow:hidden;
width:100%;

@media screen and (max-width:700px) {
    height:160px;
}
`

const Container = styled.div`
width:680px;
display:flex;
flex-direction:column;

@media screen and (max-width:700px) {
    width:100%;
}
`

const Content = styled.div`
width:100%;
min-height:100vh;
display:flex;
justify-content:center;
font-family: 'Noto Sans JP', sans-serif;
background:#1e1f24;
color:#fff;
`
